import type { FaireProductEntity } from "../../entity_types/product";

export const p_ppc4426ckq: FaireProductEntity = {
  token: "p_ppc4426ckq",
  type: "product",
  name: "Caramel Latte Softie | Squeeze Wax Melt | Squeeze Candle",
  brandName: "A Warm Welcome",
  imageUrl:
    "https://cdn.faire.com/fastly/c2cbadc6f25527b2beca021cbc04d4328246686ea98705a72e1e5a0806f1d30e.jpeg",
  priceDollars: 7.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/eddfc90afea2d7374b69d277d6b845062050829226e34c0644e5815af84f4b9f.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
